export let baseUrl = process.env.VUE_APP_ENDPOINT;
export let wsBaseUrl = process.env.VUE_APP_WSENDPOINT;
export let appEndpoint = process.env.VUE_APP_APPENDPOINT;